//
//
//
//
//
//
//
//
//
//
//
import detail from "./detail.vue";
import accountsummary from "./accountsummary.vue";
export default {
  name: "accountStatement",
  components: {
    accountsummary: accountsummary,
    detail: detail
  },
  mixins: [],
  data: function data() {
    return {
      activeIndex: 'detail'
    };
  },
  created: function created() {},
  activated: function activated() {},
  methods: {
    handover: function handover(index) {
      this.activeIndex = index;
    }
  }
};